import Web3 from 'web3';
import MarketPlace from './contracts/marketPlace.json';
import ERC721 from './contracts/ERC721.json';
import ERC20 from './contracts/erc20.json';
import AUCTION from './contracts/auction.json';
export const marketplaceContractAddress = '0xbf81C6B1593a0B747CEbff32e228013cd59591F8';
export const ERC721ContractAddress = '0xd0068C1B160B0aeCF7CEA8B4fAbe62C38C5fcf54';
export const ERC20ContractAddress = '0x628AD13837E735E8BAaED83adC221A0e01e4C793';
export const auctionContractAddress = '0xb15662598027D00897f58F8E3d0aE944Fa3ab947';
export const ethereum = window.ethereum;
export const web3 = new Web3(ethereum);
export const web3External = new Web3('https://testnet-fx-json-web3.functionx.io:8545');
export const  ListingType = {
  MARKETPLACE: "MARKETPLACE",
  NOT_LISTED: "NOT_LISTED",
  AUCTION: "AUCTION",
};

export function loadContract() {
  return new web3.eth.Contract(MarketPlace, marketplaceContractAddress);
}
export function loadContractExternal() {
  return new web3External.eth.Contract(MarketPlace, marketplaceContractAddress);
}
export function loadERC721Contract() {
  return new web3.eth.Contract(ERC721, ERC721ContractAddress);
}
export function loadERC20Contract() {
  return new web3.eth.Contract(ERC20, ERC20ContractAddress);
}
export function loadAuctionContract() {
  return new web3.eth.Contract(AUCTION, auctionContractAddress);
}

export function loadAuctionContractExternal() {
  return new web3External.eth.Contract(AUCTION, auctionContractAddress);
}
export function connectWallet(){
  ethereum.request({
    method: 'eth_requestAccounts',
  });
}
export function getCurrentWalletConnected(){
  return window.ethereum ?  window.ethereum.selectedAddress : '';
}
export function getTokenIdFromTxn(txn){
  return web3.utils.hexToNumber(txn.events[0].raw.topics[3]);
}

